import type { DeviceMode } from '@vedalib/editor'
import { useCallback, useEffect } from 'react'

import { findHiddenParentColumnsByElementId } from 'components/Editor/EditorContext/selectors/block'
import { completeElement } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getIsInteractiveMode } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'

interface IUseElementCompleted {
  block?: Block | null
  elementId: string
  completed: boolean
  deviceMode: DeviceMode
}

export const useElementCompleted = ({
  block,
  elementId,
  completed,
  deviceMode,
}: IUseElementCompleted) => {
  const dispatch = useProjectDispatch()
  const hideElement = findHiddenParentColumnsByElementId({ block: block, elementId, deviceMode })
  const isInteractive = useProjectContext(getIsInteractiveMode)
  const blockId = block?.uuid || ''

  useEffect(() => {
    if (isInteractive && (hideElement || completed || !block?.isMandatory)) {
      dispatch(
        completeElement({
          elementId,
          blockId,
          sectionId: block?.sectionId || '',
          incomplete: false,
        }),
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completed, block?.isMandatory, hideElement])

  return useCallback(
    (completedParam: boolean) => {
      if (isInteractive) {
        dispatch(
          completeElement({
            elementId,
            blockId,
            sectionId: block?.sectionId || '',
            incomplete: !completedParam,
          }),
        )
      }
    },
    [dispatch, isInteractive, elementId, blockId, block?.sectionId],
  )
}
